import React from "react";
import { connect } from "react-redux";
import { Layout, Table, Button, Icon, notification } from "antd";

import AdminHeader from "../../components/AdminHeader/AdminHeader";
import Footer from "../../components/Footer/Footer";
import classes from "./Reporting.css";

import isAuthenticated from "../../utils/isAuthenticated";

import { getFileReporting, getFileReportingByDepot } from '../../api/requests';

import {
  getReportsUsersReadPermission,
  getReportsSitesReadPermission,
  getReportsSubjectsReadPermission,
  getReportsSaeReadPermission,
  getReportsDeviationsReadPermission,
  getReportsConsentReadPermission,
  getReportsDeathReadPermission,
  getReportsBlindedAllocationsReadPermission,
  getReportsCombinedReadPermission,
  getReportsFollowUpReadPermission,
} from "../../reducers/user/selectors";

const { Content } = Layout;

const reportTypes = {
  PDF: "pdf",
  CSV: "csv",
  TXT: "txt",
};

class Reporting extends React.Component {
  state = {
    loadingReports: [],
  };

  downloadReport = async (report, type, label) => {
    try {
      if (report === 'follow_up' || report === 'user' || report === 'combined_reports') {
        this.openNotification();
        getFileReporting(report, type);
      } else {
        this.setState((state) => ({
          loadingReports: { ...state.loadingReports, [report]: true },
        }));

        let data = null;

        if (report === 'reports_drug_inventory_by_depot_read') {
          const response = await getFileReportingByDepot(report, type);
          data = response.data;
        } else {
          const response = await getFileReporting(report, type);
          data = response.data;
        }
        const blob=new Blob([data]);
        const link=document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download=`${label}.${type}`;
        link.click();

        this.setState((state) => ({
          loadingReports: { ...state.loadingReports, [report]: false },
        }));
      }
    } catch (e) {
      console.log(e);
    }
  };

  openNotification = () => {
    notification.open({
      message: "Success",
      description: "A report email has been sent",
    });
  };

  reports = [
    {
      label: "Site status report",
      name: "site",
      permission: this.props.reportsSitesReadPermission,
    },
    {
      label: "User account report (E-mail Report)",
      name: "user",
      permission: this.props.reportsUsersReadPermission,
    },
    {
      label: "Subject listing",
      name: "subject",
      permission: this.props.reportsSubjectsReadPermission,
    },
    {
      label: "SAE",
      name: "sae",
      permission: this.props.reportsSaeReadPermission,
    },
    {
      label: "Deviations",
      name: "deviations",
      permission: this.props.reportsDeviationsReadPermission,
    },
    {
      label: "Consent",
      name: "consent",
      permission: this.props.reportsConsentReadPermission,
    },
    {
      label: "Death",
      name: "death",
      permission: this.props.reportsDeathReadPermission,
    },
    {
      label: "Blinded allocations",
      name: "blinded_allocations",
      permission: this.props.reportsBlindedAllocationsReadPermission,
    },
    {
      label: "Combined reports (E-mail Report)",
      name: "combined_reports",
      permission: this.props.reportsCombinedReadPermission,
    },
    {
      label: "90d Follow-up Report (E-mail Report)",
      name: "follow_up",
      permission: this.props.reportsFollowUpReadPermission,
    }
  ];

  columns() {
    return [
      {
        key: "report",
        title: "Report",
        render: (item) => item.label,
      },
      {
        key: "actions",
        title: "Download",
        render: (item) => (
          <div style={{ display: "flex", alignItems: "center", position: 'relative' }}>
            {item.permission && item.name !== 'combined_reports' && <Button
              style={{ marginRight: "1rem", flex: 1 }}
              onClick={() => this.downloadReport(item.name, reportTypes.PDF, item.label)}
              disabled={this.state.loadingReports[item.name] || !item.permission}
            >
              PDF
            </Button>}
            {item.permission && <Button
              style={{ marginRight: "1rem", flex: 1 }}
              onClick={() => this.downloadReport(item.name, reportTypes.CSV, item.label)}
              disabled={this.state.loadingReports[item.name] || !item.permission}
            >
              CSV
            </Button>}
            {item.permission && <Button
              style={{ marginRight: "1rem", flex: 1 }}
              onClick={() => this.downloadReport(item.name, reportTypes.TXT, item.label)}
              disabled={this.state.loadingReports[item.name] || !item.permission}
            >
              TXT
            </Button>}
            {
              this.state.loadingReports[item.name] &&
              <div style={{ position: 'absolute', paddingTop: '0.3rem', background: 'rgba(255,255,255,0.9)', textAlign: 'center', width: '100%', height: '100%' }}>
                <span style={{ marginRight: '1rem', fontSize: '0.9rem', fontWeight: 'bold', color: "#faa41a", }}>Report generation in progress</span>
                <Icon
                  style={{
                    color: "#faa41a",
                  }}
                  type="loading"
                />
              </div>
            }
            </div>
        ),
      },
    ];
  }

  render() {
    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <AdminHeader />
          <Content className={classes.content}>
            <h3 className="headline-default">Reporting</h3>

            <Table
              columns={this.columns()}
              dataSource={this.reports.filter(({ permission }) => permission)}
              className={classes.table}
              pagination={false}
              rowKey="name"
            />
          </Content>
          <Footer noAdminLink />
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  reportsSitesReadPermission: getReportsSitesReadPermission(state),
  reportsUsersReadPermission: getReportsUsersReadPermission(state),
  reportsSubjectsReadPermission: getReportsSubjectsReadPermission(state),
  reportsSaeReadPermission: getReportsSaeReadPermission(state),
  reportsDeviationsReadPermission: getReportsDeviationsReadPermission(state),
  reportsConsentReadPermission: getReportsConsentReadPermission(state),
  reportsDeathReadPermission: getReportsDeathReadPermission(state),
  reportsBlindedAllocationsReadPermission: getReportsBlindedAllocationsReadPermission(state),
  reportsCombinedReadPermission: getReportsCombinedReadPermission(state),
  reportsFollowUpReadPermission: getReportsFollowUpReadPermission(state),
});

export default isAuthenticated(connect(mapStateToProps)(Reporting));



// WEBPACK FOOTER //
// ./src/containers/Reporting/Reporting.js